'use strict'
const _ = require('lodash')
const getMinimalRouters = routersMap =>
    _.mapValues(routersMap, value => ({
        prefix: value.prefix,
        pages: value.pages
    }))

const getAppRouters = ({appDefId, routersMap}) => routersMap ? Object.values(routersMap).filter(router => router.appDefinitionId === appDefId) : []

module.exports = {
    getMinimalRouters,
    getAppRouters
}
